import { each } from 'lodash'
import localStorage from 'utils/localStorage'

export const supportsFullscreen = (id) => {
  const fullScreenTargets = ['panorama_device_1', 'panorama_device_2']
  return fullScreenTargets.some((target) => target === id)
}

export const getTags = () => {
  const glimrTags = localStorage.readValue('glimrTags')
  if (glimrTags && glimrTags.tags) {
    return glimrTags.tags
  }
  return undefined
}

export const mapKeywordsWithApi = (clientKeywords, { loggedIn, device }) => {
  const blocketKeywords = {
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    logged_in: String(loggedIn),
    site_mode: device,
    supply_type: device === 'mobile' ? 'web_phone' : 'web_desktop',
    page_gen: 'react',
  }
  const result = {}
  each(blocketKeywords, (value, key) => {
    const tempKey = clientKeywords[key] || key
    result[tempKey] = value
  })
  return result
}

export const resizeSSP = (mut) => {
  if (mut.clientHeight === mut.parentElement.clientHeight) return
  if (mut.clientWidth === mut.parentElement.clientWidth) return

  // Special case of SSP not selling and appnexus backfill loading a wallpaper
  if (mut.clientHeight === 900) {
    mut.parentElement.style.cssText = ''
    mut.parentElement.parentElement.style.cssText = ''
    mut.parentElement.style.width = '1600px'
    mut.parentElement.style.height = '900px'
    mut.parentElement.style.display = 'block'
    window.document.body.style.overflowX = 'hidden'
  }

  // Detect backfill creative that has different height dimensions (!= 900) than placement and resize placement to fit
  if (mut.clientHeight !== mut.parentElement.clientHeight) {
    mut.parentElement.style.height = `${mut.clientHeight}px`
    mut.parentElement.parentElement.style.height = `${mut.clientHeight}px`
  }

  if (mut.clientWidth !== mut.parentElement.clientWidth) {
    mut.parentElement.style.width = `${mut.clientWidth}px`
    mut.parentElement.parentElement.style.width = `${mut.clientWidth}px`
  }
}

/**
 * get creative and validate that its a child of the placement
 * nb: getElementById() is only possible from document,
 *   ie: placement.getElementById() would throw an error
 */
export const getCreative = (placement) => {
  if (!placement || !placement.id) {
    return null
  }
  const creative = document.getElementById(`div_utif_${placement.id}`)
  if (creative && placement.contains(creative)) {
    return creative
  }
  return null
}

/**
 * Scale creative to match the size of the placement
 * (ie: its wrapper container)
 *
 * @todo arguments
 */
export const scaleCreative = (placement, creative) => {
  // only access width of dom elements once
  // 16px padding on both sides
  const placementWidth = placement.parentNode.clientWidth
  const creativeWidth = creative.clientWidth
  const creativeHeight = creative.clientHeight
  // check if scaling is possible/applicable, ie: we should only scale down creatives
  // avoid division by zero

  if (creativeWidth === 0 || creativeWidth <= placementWidth) {
    return
  }

  // scale and resize creative

  const factor = placementWidth / creativeWidth
  creative.style.transform = `scale(${factor.toPrecision(4)})`
  creative.style.transformOrigin = 'top'
  placement.style.width = '100%'
  placement.style.height = `${Math.round(creativeHeight * factor)}px`
}
